export default "__VITE_ASSET__3e8f8cdb__"